import {asyncRoute} from "./helper";

const routes = [
  asyncRoute('/', () => import('../pages/home'), true),
  asyncRoute('/privacy_policy', () => import('../pages/privacy_policy')),
  asyncRoute('/employee/pair', () => import('../pages/employee/pair')),
  asyncRoute('/coupon/list', () => import('../pages/coupon/list')),
  asyncRoute('*', () => import('../pages/404')),
];

export default routes;